import { render, staticRenderFns } from "./LinkNonValido.vue?vue&type=template&id=6bacba10&scoped=true&"
import script from "./LinkNonValido.vue?vue&type=script&lang=js&"
export * from "./LinkNonValido.vue?vue&type=script&lang=js&"
import style0 from "./LinkNonValido.vue?vue&type=style&index=0&id=6bacba10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bacba10",
  null
  
)

export default component.exports